import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { resetState } from "../../utils/resetState";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { error } from "console";
import { editEventError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  { event }: Boundaries["editEvent"]["request"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { request: setRequestStateToPending(), event, error: editEventError },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToPending(),
          event,
          error: editEventError,
        },
      ];
}

function handleSuccess(
  state: State,
  event: Boundaries["editEvent"]["success"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { request: setRequestStateToSuccess(), event, error: editEventError },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToSuccess(),
          event,
          error: editEventError,
        },
      ];
}

function handleFailure(
  state: State,
  { event, error }: Boundaries["editEvent"]["failure"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { request: setRequestStateToFailure(), event, error },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToFailure(),
          event,
          error,
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editEventRequested]: handleRequest,
    [events.editEventSucceeded]: handleSuccess,
    [events.editEventFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
